export const filterElements = (userRole) => [
  {
    type: "date",
    label: "Recup Date",
    name: "recupDate",
    placeholder: "Recup Date",
    minDate: false,
  },
  {
    type: "date",
    label: "Delivery Date",
    name: "date",
    placeholder: "Delivery Date",
    minDate: false,
    hidden: userRole === 3,
  },
  {
    type: "select",
    label: "Transporter",
    name: "transporter",
    placeholder: "Transporter",
    resetable: true,
    showClear: true,
    filter: true,
  },
  {
    type: "select",
    label: "Preparator",
    name: "storekeeper",
    placeholder: "Preparator",
    resetable: true,
    showClear: true,
    filter: true,
  },
  {
    type: "select",
    label: "Store",
    name: "reseller",
    placeholder: "Store",
    resetable: true,
    showClear: true,
    filter: true,
  },
];
